// deps
import React, { ReactElement, memo } from "react";

// internal-deps
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { default as CloseIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/clearLight/24";
import { PAYMENT_METHOD_DOWNTIME_HALF_CARD_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { BottomSheet, BottomSheetChildrenProps, useEffectOnce } from "@swiggy-private/core-ui";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { format } from "@swiggy-private/js-utils";

// styles
import {
    CloseButton,
    DataPointContainer,
    DataContainer,
    TagContainer,
    Divider,
    PointTextContainer,
    CtaContainer,
} from "./styles";

// icons
import { BowlPoint, RupeePoint } from "../../icons";

// constants
import { PAYMENT_METHOD_DOWNTIME_HALFCARD_TEXTS } from "@payment-ui/constants/TurboPayment";

interface IProps {
    onCloseBs: VoidFunction;
    downtimeMethodDisplayName: string;
    onLoad: VoidFunction;
    onCtaClick: VoidFunction;
}

const PaymentMethodDowntimeHalfCard = (props: IProps) => {
    const { onCloseBs, downtimeMethodDisplayName, onCtaClick, onLoad } = props;

    const customBottomSheetCloseIcon = (
        <CloseButton>
            <GenericIcon Icon={CloseIcon} onClick={onCloseBs} />
        </CloseButton>
    );

    useEffectOnce(() => {
        onLoad();
    });

    return (
        <BottomSheet
            closeIcon={customBottomSheetCloseIcon}
            data-testid={PAYMENT_METHOD_DOWNTIME_HALF_CARD_TEST_IDS.CONTAINER}
            onClose={onCloseBs}
        >
            {(_bProps: BottomSheetChildrenProps): ReactElement => {
                return (
                    <DataContainer>
                        <TagContainer>
                            <Text variant="V2.caption.neutral.black" color="primary_Accent">
                                {PAYMENT_METHOD_DOWNTIME_HALFCARD_TEXTS.TAG}
                            </Text>
                        </TagContainer>
                        <Text variant="V2.heading1.neutral.bold" color="text_Highest_Emphasis">
                            {PAYMENT_METHOD_DOWNTIME_HALFCARD_TEXTS.TITLE}
                        </Text>
                        <Divider />
                        <DataPointContainer>
                            <div>
                                <BowlPoint />
                            </div>
                            <PointTextContainer>
                                <Text variant="V2.body1.neutral.medium" color="text_Med_Emphasis">
                                    {format(PAYMENT_METHOD_DOWNTIME_HALFCARD_TEXTS.POINT1, downtimeMethodDisplayName)}
                                </Text>
                            </PointTextContainer>
                        </DataPointContainer>
                        <DataPointContainer>
                            <div>
                                <RupeePoint />
                            </div>
                            <PointTextContainer>
                                <Text variant="V2.body1.neutral.medium" color="text_Med_Emphasis">
                                    {format(PAYMENT_METHOD_DOWNTIME_HALFCARD_TEXTS.POINT2, downtimeMethodDisplayName)}
                                </Text>
                            </PointTextContainer>
                        </DataPointContainer>
                        <CtaContainer>
                            <FullWidthButton variant="specialPositive" onClick={onCtaClick}>
                                {PAYMENT_METHOD_DOWNTIME_HALFCARD_TEXTS.CTA}
                            </FullWidthButton>
                        </CtaContainer>
                    </DataContainer>
                );
            }}
        </BottomSheet>
    );
};

export default memo(PaymentMethodDowntimeHalfCard);
